export class LxcAddReportNotification {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    //GatewayUId: string;
    TypeCode: number;
    WasSuccess = false;

    ControllerId: number;
    WasResultOfUserRequest: boolean;
    MessageIdIfResultOfUserRequest: string;
    ErrorCode: string;
    Body: string;
    UId:string;
    LocationId:number;
    BlockName: string;
    BlockId : number;
}
